
// Schémas pour les pages web et la navigation

export const getWebsiteSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://www.groupefabre-environnement.fr/#website",
    "name": "Groupe Fabre Environnement",
    "alternateName": "Site officiel Groupe Fabre",
    "url": "https://www.groupefabre-environnement.fr/",
    "description": "Site officiel du Groupe Fabre Environnement - Spécialiste gestion des déchets en Occitanie",
    "inLanguage": "fr-FR",
    "isAccessibleForFree": true,
    "publisher": {
      "@type": "Organization",
      "@id": "https://www.groupefabre-environnement.fr/#organization"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.groupefabre-environnement.fr/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "mainEntity": {
      "@type": "Organization",
      "@id": "https://www.groupefabre-environnement.fr/#organization"
    }
  };
};

export const getWebPageSchema = (pageData: {
  url: string;
  title: string;
  description: string;
  datePublished?: string;
  dateModified?: string;
  breadcrumbItems?: Array<{label: string; url: string}>;
}) => {
  const schema: any = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${pageData.url}#webpage`,
    "url": pageData.url,
    "name": pageData.title,
    "description": pageData.description,
    "inLanguage": "fr-FR",
    "isPartOf": {
      "@type": "WebSite",
      "@id": "https://www.groupefabre-environnement.fr/#website"
    },
    "publisher": {
      "@type": "Organization",
      "@id": "https://www.groupefabre-environnement.fr/#organization"
    },
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": ["h1", "h2", ".intro-text", "main"]
    }
  };

  if (pageData.datePublished) {
    schema.datePublished = pageData.datePublished;
  }

  if (pageData.dateModified) {
    schema.dateModified = pageData.dateModified;
  }

  if (pageData.breadcrumbItems && pageData.breadcrumbItems.length > 0) {
    schema.breadcrumb = {
      "@type": "BreadcrumbList",
      "itemListElement": pageData.breadcrumbItems.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.label,
        "item": item.url
      }))
    };
  }

  return schema;
};

export const getFAQPageSchema = (faqItems: Array<{
  question: string;
  answer: string;
}>) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
};

export const getContactPageSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "@id": "https://www.groupefabre-environnement.fr/contact#contactpage",
    "name": "Contact - Groupe Fabre Environnement",
    "description": "Contactez Groupe Fabre Environnement pour tous vos besoins en gestion des déchets",
    "mainEntity": {
      "@type": "Organization",
      "@id": "https://www.groupefabre-environnement.fr/#organization"
    }
  };
};
